import Cross from "@components/icons/Cross"
import { useEffect, useRef } from "react"
import {
  LOADING_VIEW,
  NETWORK_VIEW,
  CONNECT_VIEW,
  IRREVERSIBLE_VIEW,
  CONFIRM_PURCHASE_VIEW,
  OWNERS_VIEW,
  CREATE_PRODUCT_CONFIRM_VIEW,
  CREATE_PRODUCT_VIEW,
  PRODUCT_VIEW,
  TOPUP_VIEW,
  // PURCHASE_PRODUCT_VIEW,
  FEE_CHANGE_VIEW,
  FINGERPRINTING_VIEW
} from "@components/Modal/modals"
import { useSliceContext } from "@components/SliceProvider"
import { View } from "./modals/types"
import { Button } from "../ui/base/button"

const Modal = ({ modalView }: { modalView: View }) => {
  const { setModalView, setIsModalTrigger } = useSliceContext()
  const { name, cross, params } = modalView
  const modalRef = useRef(null)

  function handleClick(event) {
    if (
      modalRef.current &&
      !modalRef.current.contains(event.target) &&
      !document.getElementById("floatingCart")?.contains(event.target) &&
      !document.getElementById("walletkit-container")?.contains(event.target)
    ) {
      setModalView({ name: "" })
      if (modalView.name == "TOPUP_VIEW") {
        setIsModalTrigger((prev: number) => prev + 1)
      }
    }
  }

  useEffect(() => {
    if (cross) {
      // Bind the event listener
      document.addEventListener("mousedown", handleClick)
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClick)
      }
    }
  }, [modalRef, cross])

  const content = () => {
    switch (name) {
      case "LOADING_VIEW":
        return LOADING_VIEW()
      case "NETWORK_VIEW":
        return NETWORK_VIEW(params)
      case "CONNECT_VIEW":
        return CONNECT_VIEW()
      case "IRREVERSIBLE_VIEW":
        return IRREVERSIBLE_VIEW()
      case "CONFIRM_PURCHASE_VIEW":
        return CONFIRM_PURCHASE_VIEW(params)
      case "OWNERS_VIEW":
        return OWNERS_VIEW(params)
      case "CREATE_PRODUCT_CONFIRM_VIEW":
        return CREATE_PRODUCT_CONFIRM_VIEW(params)
      case "CREATE_PRODUCT_VIEW":
        return CREATE_PRODUCT_VIEW(params)
      case "PRODUCT_VIEW":
        return PRODUCT_VIEW(params)
      case "TOPUP_VIEW":
        return TOPUP_VIEW(params)
      // case "PURCHASE_PRODUCT_VIEW":
      //   return PURCHASE_PRODUCT_VIEW(params)
      case "FEE_CHANGE_VIEW":
        return FEE_CHANGE_VIEW(params)
      case "FINGERPRINTING_VIEW":
        return FINGERPRINTING_VIEW()
    }
  }

  return (
    <div className="sl-fixed sl-top-0 sl-w-screen sl-h-screen sl-py-12 sl-overflow-y-scroll xs:sl-py-20 sl-background-modal sl-z-[150]">
      <div className="sl-absolute sl-w-full sl-h-full sl-mt-[-3rem] xs:sl-mt-[-5rem]" />
      <div
        className="sl-flex sl-items-center sl-justify-center"
        style={{ minHeight: "100%" }}
      >
        <div
          className="sl-relative sl-w-full sl-px-4 sl-py-16 sl-mx-4 sl-bg-white sl-shadow-xl xs:sl-py-20 sl-xs:px-8 sl-rounded-xl sl-max-w-screen-xs"
          ref={modalRef}
        >
          {cross && (
            <div className="sl-absolute sl-top-[24px] sl-right-[24px]">
              <Button
                onClick={() => setModalView({ name: "" })}
                variant="ghost"
                size="icon"
                className="hover:sl-text-red-500 sl-p-0"
              >
                <Cross className="sl-w-5 sl-h-5" />
              </Button>
            </div>
          )}
          {content()}
        </div>
      </div>
    </div>
  )
}

export default Modal
